import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import { MessageServiceComponent } from 'src/services/message.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    `
})
export class AppMenuComponent implements OnInit {

    model: any[];
    user: any;

    constructor(public app: AppComponent, private messageServiceComponent: MessageServiceComponent) {}

    ngOnInit() {
    this.messageServiceComponent.getUser().subscribe((res) => {
        this.user = res;

        this.model = [
    {
        label: 'Projects',
        icon: 'pi pi-list',
        routerLink: ['/projects']
    }
];

if (this.user.isAdmin) {
    this.model.push({
        label: 'Users',
        icon: 'pi pi-users',
        routerLink: ['/users']
    });
}

if (this.user.isLog) {
    this.model.push({
        label: 'Log Viewer',
        icon: 'pi pi-file-edit',
        routerLink: ['/logs']
    });
}

    });
}   
}   
